import React from 'react'
import "./ChallengeAvtiveLight.css";

export default function ChallengeActiveLight(props) {
  return (
    <div className="App">
     {/* {props.isActive==1 ? props.AcceptParticipants==1 ? <div className="colored-circle green"></div> : <div className="colored-circle orange"></div>  : <div className="colored-circle red"></div>} */}

     {props.isActive==1 &&
      <>
        {props.AcceptParticipants==1 &&
            <div className="colored-circle green"></div>
          
        }

        {props.AcceptParticipants==0 &&
          <div className="colored-circle orange"></div> 
                  
        }
      </>
     }

      {props.isActive==0 &&
        <div className="colored-circle red"></div>
      }
    </div>
  )
}
